import { render, staticRenderFns } from "./NotifPro.vue?vue&type=template&id=51c78879&scoped=true&"
import script from "./NotifPro.vue?vue&type=script&lang=js&"
export * from "./NotifPro.vue?vue&type=script&lang=js&"
import style0 from "./NotifPro.vue?vue&type=style&index=0&id=51c78879&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c78879",
  null
  
)

export default component.exports